// LoaderSpinner.tsx
import * as React from 'react';
import RingLoader from "react-spinners/RingLoader";
//import HashLoader from "react-spinners/HashLoader";

export default function LoaderSpinner({ loading }: { loading: boolean }) {
    const override = {
        display: 'block',
        margin: '0 auto',
        size: 100,
        color: "black",
    };

    return (
        <div className="ring-loader" style={{minHeight: "100vh", display: "grid", placeContent: "center"}}>
            <RingLoader {...override}
                loading={loading} />
        </div>
    );

}
